import { MIN_ISLAND_MEMBERS, UNTAGGED_KEY } from './constants';

/**
 * Assign every unit to an island. Root missions use their own primary tag;
 * nested missions inherit the root hub's.
 */
export function assignClusters(units, clusterKeyOf) {
  const N = units.length;
  const rootOf = (k) => (units[k].hubIndex === null ? k : rootOf(units[k].hubIndex));

  const rawKey = new Array(N);
  const rootCountByKey = new Map();
  for (let i = 0; i < N; i += 1) {
    if (units[i].hubIndex !== null) continue;
    const key = clusterKeyOf(units[i].task) || UNTAGGED_KEY;
    rawKey[i] = key;
    rootCountByKey.set(key, (rootCountByKey.get(key) || 0) + 1);
  }
  const effectiveKey = (key) => (
    key !== UNTAGGED_KEY && (rootCountByKey.get(key) || 0) < MIN_ISLAND_MEMBERS ? UNTAGGED_KEY : key
  );

  const clusterKeys = [];
  const clusterIndex = new Int32Array(N);
  const clusterMembers = [];
  const indexFor = (key) => {
    let ci = clusterKeys.indexOf(key);
    if (ci === -1) { ci = clusterKeys.length; clusterKeys.push(key); clusterMembers.push([]); }
    return ci;
  };
  [...new Set([...rootCountByKey.keys()].map(effectiveKey))]
    .sort((a, b) => (a === UNTAGGED_KEY) - (b === UNTAGGED_KEY) || a.localeCompare(b))
    .forEach(indexFor);

  for (let i = 0; i < N; i += 1) {
    const r = rootOf(i);
    const ci = indexFor(effectiveKey(rawKey[r]));
    clusterIndex[i] = ci;
    clusterMembers[ci].push(i);
  }
  return { clusterKeys, clusterIndex, clusterMembers };
}
